<div class="main px-5" id="vinculoForm">
  <form [formGroup]="vinculoForm" #formElement (ngSubmit)="submit()">
    <div class="col-12 mt-3 py-2 px-5 bg-light-color">
      <ng-container *ngIf="!isModal && !visualizar">
      <div class="col-12 d-flex mt-3 justify-content">
        <div class="d-flex col-10">
            <h3 class="fw-bold text-primary-color my-3">{{ inserir ? 'Cadastrar Vínculo' : 'Editar Vínculo' }}</h3>
          </div>
        </div>
      </ng-container>
        <ng-container *ngIf="isModal && visualizar">
        <h4 class="fw-bold text-primary-color my-3">Detalhes Vínculo</h4>
      </ng-container>

      <section class="row align-items-center">
        <div class="col mt-3">
          <div class="d-flex align-items-center justify-content-between">
            <p class="fw-bold text-primary-color">Dados Básicos</p>
            <i class="fi fi-rs-bank"></i>
          </div>
          <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
          <div class="col-12 py-3">
            <app-dados-basico-vinculo-form [nomePagina]="nomePagina" [vinculoForm]="vinculoForm" [vinculo]="vinculo" [acao]="acao" [isModal]="isModal"></app-dados-basico-vinculo-form>
          </div>
        </div>
      </section>

      <section class="row align-items-center" *ngIf="editar || visualizar">
        <div class="col mt-3">
          <div class="d-flex align-items-center justify-content-between">
            <p class="fw-bold text-primary-color">
              Dados da Pessoa
              <nz-tag nzColor="default" class="ms-2">Somente leitura</nz-tag>
            </p>
            <i class="fi fi-rs-bank"></i>
          </div>
          <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
          <div class="col-12 py-3">
            <ng-container *ngIf="carregandoPessoa; else pessoaPronta">
              <div class="area-interna-carregando">
                <nz-spin nzSimple nzTip="Carregando..."></nz-spin>
              </div>
            </ng-container>
            <ng-template #pessoaPronta>
              <app-pessoa-vinculada-info *ngIf="pessoaVinculada" [pessoa]="pessoaVinculada"></app-pessoa-vinculada-info>
            </ng-template>
          </div>
        </div>
      </section>

      <section class="row align-items-center" *ngIf="!(!obj && isModal && tipoEntidadeId === tipoEntidadeEnum.Area)">
        <div class="col mt-3">
          <div class="d-flex align-items-center justify-content-between">
            <p class="fw-bold text-primary-color">Contatos</p>
            <i class="fi fi-rs-bank"></i>
          </div>
          <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
          <div class="col-12 py-3">
            <ng-container *ngIf="carregandoComplemento; else contatosProntos">
              <div class="area-interna-carregando">
                <nz-spin nzSimple nzTip="Carregando..."></nz-spin>
              </div>
            </ng-container>
            <ng-template #contatosProntos>
              <app-contato-vinculo-form [nomePagina]="nomePagina" [form]="vinculoForm" [dataSet]="vinculo" [dadosIdSelecionado]="dadosIdSelecionado" [pessoaIdSelecionado]="pessoaIdSelecionado" [entidadeIdSelecionado]="entidadeIdSelecionado" [paginaVinculo]="true" [contato]="contato" [dataSet]="dataSet" (contatoEmit)="receberDadosContato($event)"></app-contato-vinculo-form>
            </ng-template>
          </div>
        </div>
      </section>

      <!-- <section class="row align-items-center" *ngIf="!(!obj && isModal && tipoEntidadeId === tipoEntidadeEnum.Area)">
        <div class="col mt-3">
          <div class="d-flex align-items-center justify-content-between">
            <p class="fw-bold text-primary-color">Outros Contatos</p>
            <i class="fi fi-rs-bank"></i>
          </div>
          <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
          <div class="col-12 py-3">
            <app-outros-contatos-vinculo-list [nomePagina]="nomePagina" [form]="vinculoForm"
              [data]="vinculo" [dadosIdSelecionado]="dadosIdSelecionado" [pessoaIdSelecionado]="pessoaIdSelecionado" [entidadeIdSelecionado]="entidadeIdSelecionado"></app-outros-contatos-vinculo-list>
          </div>
        </div>
      </section> -->

      <section class="row align-items-center">
        <div class="col mt-3">
          <div class="d-flex align-items-center justify-content-between">
            <p class="fw-bold text-primary-color">Grupos</p>
            <i class="fi fi-rs-bank"></i>
          </div>
          <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
          <div class="col-12 py-3">
            <ng-container *ngIf="carregandoComplemento; else gruposProntos">
              <div class="area-interna-carregando">
                <nz-spin nzSimple nzTip="Carregando..."></nz-spin>
              </div>
            </ng-container>
            <ng-template #gruposProntos>
              <app-grupo-vinculo [nomePagina]="nomePagina" [form]="vinculoForm" [data]="vinculo"></app-grupo-vinculo>
            </ng-template>
          </div>
        </div>
      </section>

      <section class="row align-items-center">
        <div class="col mt-3">
          <div class="d-flex align-items-center justify-content-between">
            <p class="fw-bold text-primary-color">Documentos</p>
            <i class="fi fi-rs-bank"></i>
          </div>
          <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
          <div class="col-12 py-3">
            <ng-container *ngIf="carregandoComplemento; else documentosProntos">
              <div class="area-interna-carregando">
                <nz-spin nzSimple nzTip="Carregando..."></nz-spin>
              </div>
            </ng-container>
            <ng-template #documentosProntos>
              <app-documento-vinculo-list [nomePagina]="nomePagina" [documentoForm]="vinculoForm" [data]="vinculo"></app-documento-vinculo-list>
            </ng-template>
          </div>
        </div>
      </section>

      <nz-divider></nz-divider>

      <div id="footer-btns-fixed" [ngClass]="!isModal ? 'col-12 footer-btns-fixed' : 'col-12'">
        <div class="row mb-4">
          <div class="d-flex justify-content-between w-100">
            <div class="d-flex col-4">
              <button nz-button nzType="default" nzSize="large"
                class="d-flex justify-content-center fw-semibold rounded-3 fs-6" type="button" (click)="voltar()">
                Voltar
                <span class="fs-3 ms-2 mdi--search"></span>
              </button>
              <ng-container *ngIf="exibirBotaoIrParaPessoa()">
                <button nz-button nzType="primary" nzSize="large"
                  class="d-flex justify-content-center fw-semibold rounded-3 fs-6 ms-2" type="button" (click)="goToPessoa()">
                  Ir para Pessoa
                  <span class="fs-3 ms-2 mdi--search"></span>
                </button>
              </ng-container>
              <ng-container *ngIf="exibirBotaoIrParaEntidade()">
                <button nz-button nzType="primary" nzSize="large"
                  class="d-flex justify-content-center fw-semibold rounded-3 fs-6 ms-2" type="button" (click)="goToEntidade()">
                  Ir para Entidade
                  <span class="fs-3 ms-2 mdi--search"></span>
                </button>
              </ng-container>
            </div>

            <div class="col-4 text-center" *ngIf="entidadeNome">
              <p class="fs-5 fw-bold">{{ entidadeNome }}</p>
            </div>

            <div class="col-4 d-flex justify-content-end" *ngIf="verificarPessoaEntidade()">
                  <button nz-button nzType="primary" nzSize="large"
                    class="d-flex justify-content-center fw-semibold rounded-3 fs-6" type="submit">
                    Salvar
                    <span class="fs-3 ms-2 mdi--search"></span>
                  </button>
            </div>

            <div class="col-4 d-flex justify-content-end">
              <ng-container *ngIf="isLotacaoAdm">
                <ng-template [ngxPermissionsOnly]="[roleEnum.VinculoGravacao, perfilEnum.Administrador, perfilEnum.Validador]">
                  <ng-container *ngIf="inserir">
                    <button nz-button nzType="primary" nzSize="large"
                      class="d-flex justify-content-center fw-semibold rounded-3 fs-6" type="submit">
                      Salvar cadastro
                      <span class="fs-3 ms-2 mdi--search"></span>
                    </button>
                  </ng-container>
                </ng-template>

                <ng-template [ngxPermissionsOnly]="[roleEnum.VinculoEdicao, perfilEnum.Administrador, perfilEnum.Validador]">
                  <ng-container *ngIf="editar && podeCadastrarEditar && perfisPodemEditar || (this.vinculoForm?.get('tipoVinculoId')?.value === tipoVinculoEnum.Lotacao && this.perfilUsuarioLogado === perfilEnum.Validador)">
                    <button nz-button nzType="primary" nzSize="large"
                      class="d-flex justify-content-center fw-semibold rounded-3 fs-6" type="submit">
                      Editar cadastro
                      <span class="fs-3 ms-2 mdi--search"></span>
                    </button>
                  </ng-container>
                </ng-template>
              </ng-container>
            </div>
          </div>
        </div>
      </div>


    </div>
  </form>
</div>
